/**
 * Created by bzm on 2015/9/21.
 */
'use strict';
angular.module("pieceMgr.multiDocEdit", []).directive("trsFragDocsEdit", ["$validation", "$compile", "$filter", function($validation, $compile, $filter) {
    return {
        restrict: "E",
        templateUrl: "./editingCenter/website/fragmentManagement/multiDoc/multiDoc_doc_edit_tpl.html",
        replace: true,
        scope: {
            editJson: "@",
            editJsonNew: "=",
            widgetParams: "=",
            required: "@"
        },
        link: function(scope, element, attrs) {
            var editJson = JSON.parse(scope.editJson);
            scope.editJsonTemp = editJson;
            if (typeof scope.editJsonTemp.reltime == 'object') {
                scope.editJsonTemp.reltime = $filter('date')(scope.editJsonTemp.reltime, "yyyy-MM-dd HH:mm").toString()
            } else if (scope.editJsonTemp.reltime.indexOf("T") > -1) {
                scope.editJsonTemp.reltime = scope.editJsonTemp.reltime.replace("T", " ").split(":").splice(0, 2).join(":");
            }
            var targetDiv = element.find('all');
            var singleDoc = '<trs-frag-single-doc widget-params="widgetParams" required="' + scope.required + '" json-obj="editJsonTemp"></trs-frag-single-doc>';
            singleDoc = $compile(singleDoc)(scope);
            $(targetDiv).html(singleDoc);
            scope.cancel = function() {
                scope.$parent.$close();
            };
            scope.confirm = function() {
                scope.editJsonNew = scope.editJsonTemp;
                setTimeout(function() {
                    scope.$parent.$close();
                }, 500);
            };
            scope.$watch("editJsonTemp.reltime", function(newV, oldV) {
                if (newV != oldV) {
                    if (typeof scope.editJsonTemp.reltime == 'object') {
                        scope.editJsonTemp.reltime = $filter('date')(scope.editJsonTemp.reltime, "yyyy-MM-dd HH:mm").toString()
                    } else if (newV.indexOf("T") > -1) {
                        scope.editJsonTemp.reltime = newV.replace("T", " ").split(":").splice(0, 2).join(":");
                    }
                }
            });
        }
    };
}]);